import { render, staticRenderFns } from "./BookingOpenedCard.vue?vue&type=template&id=2a699adf&scoped=true&"
import script from "./BookingOpenedCard.vue?vue&type=script&lang=js&"
export * from "./BookingOpenedCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingOpenedCard.vue?vue&type=style&index=0&id=2a699adf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a699adf",
  null
  
)

export default component.exports